/* @jsx jsx */
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Tooltip from '@atlaskit/tooltip';
import Button from '@atlaskit/button/standard-button';
import Enter from '../../assets/Enter';
import messages from './messages';
import { submitButtonStyles } from './styles';
export const SubmitButton = ({
  disabled,
  tabIndex
}) => {
  const {
    formatMessage
  } = useIntl();
  return jsx(Tooltip, {
    content: formatMessage(messages.submitTooltip),
    hideTooltipOnClick: true,
    position: "top"
  }, jsx(Button, {
    "aria-label": formatMessage(messages.submitLabel),
    css: submitButtonStyles,
    type: "submit",
    appearance: "subtle",
    spacing: "compact",
    isDisabled: disabled,
    iconBefore: jsx(Enter, null),
    tabIndex: tabIndex
  }));
};